export default __webpack_public_path__ + "static/media/kayaguneribes10.8df8b6d5.jpg";